import { functions } from "@/services/firebase";

// Firebase Functions callable endpoints for tournament pipeline
const getCloudTaskStatusCallable = functions.httpsCallable("pipeline-getCloudTaskStatus");

/**
 * Get the status of a Google Cloud Task
 * @param {string} taskName - The full Cloud Task name
 * @returns {Promise<Object>} Task status information
 */
export async function getCloudTaskStatus(taskName) {
  if (!taskName) {
    return {
      status: 'NO_TASK',
      error: 'No task name provided'
    };
  }

  try {
    const result = await getCloudTaskStatusCallable({ taskName });
    return result.data;
  } catch (error) {
    console.error('Error calling getCloudTaskStatus:', error);
    return {
      status: 'ERROR',
      error: error.message || 'Failed to get task status'
    };
  }
}
